import React from "react";

// import Freezer from "./tabs/freezer";
// import Info from "./tabs/info/osViewTabInfo";
import Wallet from "./tabs/wallet";
import ViewTabs from "./tabs";
import Transactions from "./tabs/transactions";
import Rewards from "./tabs/rewards";
import { Container } from "@mui/material";

const TabsView = React.memo(({ onClose }) => {
  return (
    <ViewTabs>
      {({ tabValue, TabPanel }) => (
        <div>
          <TabPanel value={tabValue} index={0}>
            <Wallet />
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <Transactions />
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            <Rewards />
          </TabPanel>
        </div>
      )}
    </ViewTabs>
  );
});

export default TabsView;
